module.exports = __webpack_public_path__ + "icon_team.89a89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_team.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_team.svg
// module chunks = main